import LOGO from '@/assets/images/logo-eci.png';
import IMAGECHART from '@/assets/images/image-login.png';
import OVERLAY from '@/assets/images/overlay-circle-login.png';

export default function AuthBackground() {
  return (
    <div className="relative w-full h-full">
      <img
        src={OVERLAY}
        alt="Background overlay"
        className="absolute top-0 left-0 pointer-events-none z-0"
      />
      <div className="pt-[4.8rem] pl-[5.6rem] pr-[8rem] relative z-10 w-full h-full">
        <img src={LOGO} alt="LOGO-ECI" className="w-[16.1rem] h-[4.5rem]" />

        <div className="mt-[11.7rem] mb-[7rem] flex justify-center items-center">
          <img src={IMAGECHART} alt="LOGO-NexgenBross" className="w-[52.5rem] h-[38.4rem]" />
        </div>

        <div className="flex flex-col justify-center gap-[3.6rem]">
          <h2 className="text-[3rem] font-semibold text-[#F7FAFC] text-center">
            OFFSHORE COMPANY FORMATION
          </h2>
          <p className="text-center font-normal text-[2rem] text-[#CFD9E0]">
            Incorporate your company in the US, UK, Singapore,
            <br /> or Hong Kong with complete support for bank <br /> accounts, payment gateways,
            and tax <br /> compliance — all in one solution.
          </p>
        </div>
      </div>
    </div>
  );
}
